import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchStaffNotifications = async ({ page = 1 }) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${__API_URL__}/api/staff-notifications/`, {
    headers: { Authorization: `Token ${token}` },
    params: { page },
  });
  return response.data;
};

const useGetStaffNotifications = ({ page = 1, enabled = true } = {}) => {
  return useQuery({
    queryKey: ["staff-notifications", page],
    queryFn: () => fetchStaffNotifications({ page }),
    enabled,
    keepPreviousData: true,
  });
};

export default useGetStaffNotifications;
